
export class PageBanner {
  id?: number;
  tourId?: number;
  pageCode?: string;
  name?: string;
}
